import {Form} from "@angular/forms";

export class Ticket {
  public id:number;
  public 	firstname:string;
  public lastname:string;
  public 	email:string;
  public event_id:number;
  public order_id:number;
  public pricing_id:number;
  public pricing_label:string;
  public user_id:number;
  public statut:number;
  public mailSended:any;
  public isPromo:boolean=false;
  public qrcode:string;
  public form :any;
  public reduction:any =0;
  public business:any;
  public accreditationType:any;
  public substractionrequest_id:any;
  public options :any = [];





  constructor() {}

}
